{
    "gameAssets": "pictures/images/poker-web-client/"
}
